import * as services from './dashboard.services'

export default {
  data() {
    return {
      DashboardChoiceDependsOn:       ['incidents','chemicalrecord','activity'], 

      Incidents: [],
      Accidents: [],
      logs: [],
      events: [],

      locationId: '',
      poolId: '',
      locationName: '',
      
      dLocation: '',
      config: {
        header: {
          right: ''
        },
        edit: false,
        editable: false,
        stick: true,
        defaultView: 'month'
      },
    }
  },

  updated() {
    //alert("updated")
  },

  mounted() {
    tooltip.startTooltip(50)
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.Incidents.length = 0
      context.Accidents.length = 0
      context.locationId = data.LocationId ? data.LocationId : 0
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      context.$router.app.$emit('dash_loc', data.LocationName)
      
      context.GetAllIncidentsByLocation(context.locationId)
      context.GetAllDailylogs(null, null, null, context.locationId)
      context.GetActivityCalendar(context.locationId, context.poolId)

    })
    this.$router.app.$on('emittedpool_obj', (data) => {
      context.poolId = data.PoolId ? data.PoolId : ''
      context.poolName = data.PoolName ? '(Aquatic Venue : ' + data.PoolName + ')' : ''
      if (context.poolId) {
        context.GetActivityCalendar(context.locationId, context.poolId)
      }
    })


  },
  beforeDestroy() {
    //this.$root.$off('emittedlocation_obj') // - FG - FOOF - Jan 23 2019
  },

  methods: {
    //FG - FOOF - After Cert - First Release Security (7)
    //METHODS BELOW HELP TO CONTROL WHAT IS DISPLAYED BY THE GUI
    //
      //  I use methods like this rather than set variables at say mounting
      //  because it is more real time.
      //
      //SECURITY EXAMPLE: I use the methods below in the Dashboard.vue to
      //control whether the incident/accidents lists etc. are displayed
    displayDashboardPage:     function() {return this.$hydrowareSecurityJS.canDisplay_A(this.DashboardChoiceDependsOn)},
    showIncidentsList: function() {return this.$hydrowareSecurityJS.canView_A('incidents')},
    showAccidentsList: function() {return this.$hydrowareSecurityJS.canView_A('incidents')},
    showDailyLog     : function() {return this.$hydrowareSecurityJS.canView_A('chemicalrecord')},
    showCalendar     : function() {return this.$hydrowareSecurityJS.canView_A('activity')},
    //METHODS THAT DECIDE WHETHER MENU CHOICES ARE SHOWN - ABOVE

    //FG - FOOF - After Cert - First Release Security (7)
    //  NOTE: FOR THE FIRST RELEASE EITHER BOTH OR NEITHER WILL SHOW
    GetClassForIncidentsTable() {
      if(this.showIncidentsList() && this.showAccidentsList())
        return 'col-lg-6'
      else
        return 'col-lg-12'
    },

    GetAllIncidentsByLocation(id) {
      let context = this

      //FG - FOOF - After Cert - First Release Security (7) - added so we don't go to 
      //the server unecassarily! 
      //NOTE: FOR FIRST RELEASE INCIDENTS AND ACCIDENTS ARE TREATED THE SAME
      if( context.showIncidentsList == false) {
        context.Incidents = []
        context.Accidents = []
        //context.showIncidentsList=false;
        //context.showAccidentsList=false;
        return;
      }

      //FG - FOOF - After Cert - First Release Security (7) reworked "then" function
      services.AllIncidentsByLocation(id).then(function (data) {
        //If security does not allow this then data will begin with "Restricted"
        context.Incidents = []
        context.Accidents = []
        if(context.$hydrowareSecurityJS.isDataRestricted(data)) {
          //context.showIncidentsList=false;
          //context.showAccidentsList=false;
          return;
        }
        //If we reach this then this action is allowed
        //context.showIncidentsList=true;
        //context.showAccidentsList=true;
        data.map(function (item) {
          if (item.IncidentType == 'Incident') {
            context.Incidents.push(item)
          } else if (item.IncidentType == 'Accident') {
            context.Accidents.push(item)
          }
        })
      }, 
      (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllDailylogs(isActive, pagestart, pagelimit, location) {
      let context = this

      //FG - FOOF - After Cert - First Release Security (7) - added so we don't go to 
      //the server unecassarily!
      if( this.showDailyLog() == false) {
        context.logs = []
        //context.showDailyLog=false;
        return;
      }

      var pos = ''
      var pos1 = ''
      //FG - FOOF - After Cert - First Release Security (7) Reworked "then" function
      services.AllDailyLogs(isActive, pagestart, pagelimit, location).then(function (response) {

        //If security does not allow this then data will begin with "Restricted"
        context.logs = []
        if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
          //context.showDailyLog = false
          return;
        }
        //If we reach this then this action is allowed
        //context.showDailyLog=true;

        var limit = 1
        if (response && response != null) {
          context.logs = []
          var x = []
          response.map(function (item, index) {
            item.TemplateReadings.map(function (item2, index2) {
              pos1 = context.logs.map(function (e) {
                return e.rid
              }).indexOf(item.Id)
              if (pos1 < 0) {
                context.logs.push({
                  pid: item2.PoolId,
                  rid: item.Id,
                  venue: item2.PoolName ? item2.PoolName : item.LocationName,
                  LocationName: item.LocationName,
                  AddedOn: item.AddedOn,
                  AddedBy: item.AddedBy,
                })

              }

              pos = context.logs.map(function (e) {
                if (e.rid == item.Id) {
                  return e.pid
                }

              }).indexOf(item2.PoolId)
              if (pos > -1) {

                context.logs[pos][item2.Name] = item2.LogTemplateReadingValue

                //  x[pos]['rid'] = item.Id

              } else {
                context.logs.push({
                  pid: item2.PoolId,
                  rid: item.Id,
                  venue: item2.PoolName ? item2.PoolName : item.LocationName,
                  LocationName: item.LocationName,
                  AddedOn: item.AddedOn,
                  AddedBy: item.AddedBy,
                })
              }

            })

          })


        } else {

          context.logs = []
        }


        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },
    FormatDate(date) {
      let newdate = new Date(date)
      let formatteddate = newdate.getDate() + '-' + (newdate.getMonth() + 1) + '-' + newdate.getFullYear()
      return formatteddate

    },
    redirectToIncident(data) {
      let routeData = this.$router.resolve({
        name: 'incidents',
        query: {
          id: data.Id,
          location: this.locationName,
          locationId: this.locationId,
          type: data.IncidentType
        }
      })
      window.open(routeData.href, '_self')
    },
    redirectToActivityPatron() {

      let routeData = this.$router.resolve({
        name: 'activitylist',
        query: {
          location: this.locationName
        }
      })
      window.open(routeData.href, '_self')
    },
    redirectToChemrecords(data) {
      let routeData = this.$router.resolve({
        name: 'chemicalrecord',
        query: {
          id: data.rid
        }
      })
      window.open(routeData.href, '_self')
    },
    ShowAddActivities() {
      this.ShowActivityList = false
      this.btn = "Save"
      let context = this;
      this.addActivities = {

        "LocationId": "",
        "PoolIds": [],
        "Organizer": "",
        "StartDate": "",
        "EndDate": "",
        "Description": "",
        "PoolLane": "",
        "PoolZone": "",
        "Notes": "",
        "Capacity": "",
        "TargetRevenue": "",
        "TargetExpense": "",
        "TargetProfit": "",
        "MondayStart": "",
        "MondayEnd": "",
        "TuesdayStart": "",
        "TuesdayEnd": "",
        "WednesdayStart": "",
        "WednesdayEnd": "",
        "ThursdayStart": "",
        "ThursdayEnd": "",
        "FridayStart": "",
        "FridayEnd": "",
        "SaturdayStart": "",
        "SaturdayEnd": "",
        "SundayStart": "",
        "SundayEnd": "",
        "Id": "",
        "ProgramName": "",
        "ActivityTypeId": "",
        "ActivityTypeDesc": ""
      }
      this.WeekDays = this.SetWeekDays();
    },
    eventSelected(event) {

      this.eventDetails = []
      this.eventDetails.push(event.data)
      $('#eventsModel').modal('show')
    },
    GetActivityCalendar(locationid, poolId) {
      let context = this
      context.events=[]

      //FG - FOOF - After Cert - First Release Security (7) - added so we don't go to 
      //the server unecassarily!
      if(context.showCalendar()==false) {
        context.events = []
        //context.showCalendar=false;
        return;
      }

      //FG - After Cert - First Release Security - line below was added when coding security
      //if (poolId) {//FG - THIS WAS HERE BEFORE MY CODE SEEMS CALENDAR IS ONLY FOR SPECIFIC POOL
        //If security does not allow this then data will begin with "Restricted"
        //FG - FOOF - After Cert - First Release Security (7) reworked "then" function
        var poolIdForServerCall = poolId==""? 0 : poolId;
        services.GetActivityCalendar(locationid, poolIdForServerCall).then(function (response) {

          if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
            //context.showCalendar=false;
            return;
          }
        //If we reach this then this action is allowed
          //context.showCalendar=true;
          if (response) {
            context.events=[]
            if (response.length > 0) {
              response.map(function (el) {
                context.events.push({
                  title: el.ProgramName,
                  start: context.$moment(el.StartDate).format('YYYY-MM-DD'),
                  end: context.$moment(el.EndDate).format('YYYY-MM-DD') + '' + 'T23:59:00',
                  data: el,
                  allDay: false
                })
              })

            }
          }
        }, (error) => {

        })
      //}

    }


  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/dashboard.controller.js